import { Action } from 'redux'
import actions, { SelectReportAction, SetReportsAction, SoftDeleteReportAction } from './actions'
import ReportsState, { defaultReportsState } from './ReportsState'

export const reducer = (state: ReportsState = defaultReportsState, action: Action) => {
    switch(action.type) {
        case actions.SET_REPORTS: {
            const setReportsAction = action as SetReportsAction
            return {
                selectedReport: null,
                reports: setReportsAction.reports
            }
        }
        case actions.SELECT_REPORT: {
            const selectReportAction = action as SelectReportAction
            return {
                ...state,
                selectedReport: selectReportAction.report
            }
        }
        case actions.SOFT_DELETE_REPORT: {
            const softDeleteReport = action as SoftDeleteReportAction
            return {
                ...state,
                reports: state.reports.filter(x => x.id !== softDeleteReport.reportId)
            }
        }
        default:
            return state
    }
}
